// Materials Section Component
import { I18nManager } from "../../services/i18n-manager";

export class MaterialsSection {
  private i18nManager: I18nManager;

  constructor(i18nManager: I18nManager) {
    this.i18nManager = i18nManager;
  }

  init(): void {
    this.setupEventListeners();
    this.updateContent();
  }

  private setupEventListeners(): void {
    // Listen for language changes
    this.i18nManager.onLanguageChange(() => {
      this.updateContent();
    });
  }

  private updateContent(): void {
    // Update section title
    const sectionTitle = document.querySelector(
      ".materials-section .section-title"
    );
    if (sectionTitle) {
      sectionTitle.textContent = this.i18nManager.t("materials.title");
    }

    // Update section description
    const sectionDescription = document.querySelector(
      ".materials-section .section-description"
    );
    if (sectionDescription) {
      sectionDescription.textContent = this.i18nManager.t(
        "materials.description"
      );
    }

    // Update card titles and descriptions
    const qualityCard = document.querySelector(
      ".materials-card[data-card='quality']"
    );
    if (qualityCard) {
      const title = qualityCard.querySelector(".materials-card-title");
      const description = qualityCard.querySelector(
        ".materials-card-description"
      );
      if (title) {
        title.textContent = this.i18nManager.t("materials.quality.title");
      }
      if (description) {
        description.textContent = this.i18nManager.t(
          "materials.quality.description"
        );
      }
    }

    const environmentalCard = document.querySelector(
      ".materials-card[data-card='environmental']"
    );
    if (environmentalCard) {
      const title = environmentalCard.querySelector(".materials-card-title");
      const description = environmentalCard.querySelector(
        ".materials-card-description"
      );
      if (title) {
        title.textContent = this.i18nManager.t(
          "materials.environmental.title"
        );
      }
      if (description) {
        description.textContent = this.i18nManager.t(
          "materials.environmental.description"
        );
      }
    }

    const healthCard = document.querySelector(
      ".materials-card[data-card='health']"
    );
    if (healthCard) {
      const title = healthCard.querySelector(".materials-card-title");
      const description = healthCard.querySelector(
        ".materials-card-description"
      );
      if (title) {
        title.textContent = this.i18nManager.t("materials.health.title");
      }
      if (description) {
        description.textContent = this.i18nManager.t(
          "materials.health.description"
        );
      }
    }
  }
}

